var u = `	
\v\f\r                　\u2028\u2029\uFEFF`;
export {
  u as w
};
